/**
 * Phase 4a — `tmpl/more-notes-popup.tmpl` (67 lines), a fully static template:
 * `openMorePopUp` (main.js:728-750) compiles it with `{ data: {} }` because the
 * only loop that would have filled `data` is commented out (:741-746, its
 * `getManufacturerForRow`/`getSeriesForRow` helpers are dead — discovery §10).
 *
 * `.active` is added immediately after the append (:749), so the popup is
 * always mounted active — the class is on the wrapper for CSS/Esc parity.
 *
 * ⚠ Legacy APPENDS A NEW NODE ON EVERY CLICK (no dedupe), and the CLOSE button
 * runs `$('.notes').remove()` (:700-702), which removes ALL of them at once.
 * `SizerPage` reproduces that by rendering N copies.
 */
const MoreNotesPopup = ({ onClose }: { onClose: () => void }) => (
  <div className="notes popup-wrapper active">
    <div className="popup-content">
      <h2 className="popup-heading">more notes...</h2>
      <div className="clearfix row popup-content-part">
        <div className="label">Defaults used in the Air Handling Unit Sizer</div>
        <div className="simple-contents">
          <div className="label">Cabinet</div>
          <div className="col-xs-12">
            <div className="col-xs-12">CW and CH are cabinet Outside dimensions.</div>
          </div>
          <div className="col-xs-12">
            <div className="col-xs-12">CH cabinet height does not include unit base height.</div>
          </div>
          <div className="col-xs-12">
            <div className="col-xs-12">
              CH Cabinet Height does not include height of roof seam and roof slope (when
              applicable).
            </div>
          </div>
          <div className="col-xs-12">
            <div className="col-xs-12">
              Cabinet airway width and height calculations are based on 16 gauge steel outer skin
              and 20 gauge steel inner liner.
            </div>
          </div>
        </div>
        <div className="simple-contents">
          <div className="label">Coil</div>
          <div className="col-xs-12">
            <div className="col-xs-6">Type</div>
            <div className="col-xs-6">Fluid</div>
          </div>
          <div className="col-xs-12">
            <div className="col-xs-6">Minimum sides, top &amp; bottom clearances</div>
            <div className="col-xs-6">Per CMS</div>
          </div>
          <div className="col-xs-12">
            <div className="col-xs-6">Height from Floor</div>
            <div className="col-xs-6">0.00 inch</div>
          </div>
        </div>
        <div className="simple-contents">
          <div className="label">Filter</div>
          <div className="col-xs-12">
            <div className="col-xs-6">Arrangement</div>
            <div className="col-xs-6">Flat-Bank</div>
          </div>
          <div className="col-xs-12">
            <div className="col-xs-6">Height from Floor</div>
            <div className="col-xs-6">Per CMS minimum</div>
          </div>
        </div>
      </div>
      <div className="popup-control-buttons">
        <button type="button" className="close_notes" name="close_notes" onClick={onClose}>
          CLOSE
        </button>
      </div>
    </div>
  </div>
);

export default MoreNotesPopup;
